import Header from "Components/Header/Header";

const MARKETPLACE_URL = "https://frenchflorist.myshopify.com/";

// Shown when a store outside STORE_SCOPED_PERMISSIONS opens a store-scoped
// module — steers them to the Marketplace instead of the feature. `module`
// doubles as the page title (it is the human-readable module name).
export default function MarketplaceNotice({ module }) {
  return (
    <>
      <Header title={module} />
      <div style={{ padding: "40px", textAlign: "left", fontSize: "1.1rem" }}>
        Our new marketplace is live; click{" "}
        <a
          href={MARKETPLACE_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "underline" }}
        >
          here
        </a>{" "}
        to use that.
      </div>
    </>
  );
}
